import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import ListViewIcon from '@material-ui/icons/ViewList';
import CardViewIcon from '@material-ui/icons/ViewStream';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import { change, initialize, submit } from 'redux-form';
import { INTERCOM_EXTENSION_TYPES, MATCH_TAG_MODE, VIEW_MODES } from '../_config/consts';
import { localizeHelpCenterLink } from '../_config/utils.js';
import IntercomExtensionIconCustom from '../components/CustomIcons/IntercomExtensionIconCustom.jsx';
import ExtensionListView from '../components/Extension/ExtensionListView.jsx';
import ExtensionTableView from '../components/Extension/ExtensionTableView.jsx';
import ExtensionForm from '../components/forms/Extension/ExtensionForm.jsx';
import TranslatableOption from '../components/forms/Fields/TranslatableOption.jsx';
import MDButton from '../components/MDButton/MDButton.jsx';
import OperationalView from '../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../components/PresentationalView/PresentationalViewHeader.jsx';
import * as IntercomActions from '../redux/actions/intercom.actions';
import * as ModalActions from '../redux/actions/modal.actions';
import * as TagActions from '../redux/actions/tag.actions';
import * as UtilsActions from '../redux/actions/utils.actions';

let filterTimeout;
@connect(state => ({ 
  userTags: state.tags.user.data, 
  form: state.form.ExtensionForm, 
  intercom: state.intercom, 
  routing: state.router, 
  languange: state.settings.language, 
  viewLoading: state.utils.viewLoading, 
  themeName: state.settings.items.theme.data.themeName,
  virtualIntercomLimits: state.intercom.virtualIntercomLimits,
}))
class IntercomExtensionsManagement extends React.Component {
  constructor(props) {
    super(props);
    const cachedViewMode = localStorage.getItem('extensionViewMode');
    this.state = {
      activeTab: cachedViewMode && cachedViewMode === VIEW_MODES.CARDS ? 1 : 0,
    };
  }

  async componentWillMount() {
    const { dispatch, routing } = this.props;
    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    this.onFetchExtensions();
    dispatch(IntercomActions.fetchExtensionGroups());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.selectExtension({}));
    dispatch(IntercomActions.setExtensionOperationalMode(false));
  }

  async onFetchExtensions() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      await dispatch(IntercomActions.fetchExtensions());
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  onNewExtensionButtonClicked() {
    const { dispatch, virtualIntercomLimits, intercom: { extensions: { pagination } } } = this.props;
    const numberOfExtensions = pagination && pagination.totalElements ? pagination.totalElements : 0;
    
    // Check extension limit
    if (virtualIntercomLimits && virtualIntercomLimits.maxExtensionsNumber !== -1 && numberOfExtensions >= virtualIntercomLimits.maxExtensionsNumber) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_MODAL',
        modalProps: {
          type: 'DEFAULT_ERROR',
          defaultMessage: <Entity entity="extensionLimitReachedUpgrade" />,
        },
      }));
      return;
    }
    
    dispatch(IntercomActions.selectExtension({}));
    dispatch(initialize('ExtensionForm', {}));
    dispatch(IntercomActions.setExtensionOperationalMode(true));
  }

  onCloseOperationalSection() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.selectExtension({}));
    dispatch(IntercomActions.setExtensionOperationalMode(false));
  }

  onSetFilter(field, value) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.setExtensionFilter(field, value));
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(async () => {
      await this.onFetchExtensions();
    }, 500);
  }

  onSearchReset() {
    const { dispatch } = this.props;
    dispatch(IntercomActions.resetExtensionsFilters());
    this.onFetchExtensions();
  }

  onExportElements(format) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.exportExtensions(format));
  }
  
  onExtensionsListModeChange(activeTab) {
    const { dispatch } = this.props;
    const selectedViewMode = activeTab === 0 ? VIEW_MODES.TABLE : VIEW_MODES.CARDS;
    this.setState({ activeTab });
    IntercomActions.setExtensionViewMode(selectedViewMode);
    if (activeTab === 0) {
      dispatch(IntercomActions.resetExtensionsPaginationData());
      dispatch(IntercomActions.fetchExtensions());
    }
  }

  onFetchExtensionsOnPage(page) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.fetchExtensions(page));
  }

  async onSelectExtension(extension) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.selectExtension(extension));
    try {
      const formData = {
        ...extension,
        isReception: extension.type === INTERCOM_EXTENSION_TYPES.RECEPTION || false,
      };
      dispatch(initialize('ExtensionForm', formData));
      dispatch(IntercomActions.setExtensionOperationalMode(true));
    } catch (error) {
      dispatch(IntercomActions.selectExtension({}));
    }
  }

  onDeleteExtension(extensionId) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="extensionDeleteConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeleteExtensionConfirmed(extensionId),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeleteExtensionConfirmed(extensionId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(IntercomActions.deleteExtension(extensionId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchExtensions();
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionDeleteSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionDeleteError" /></h6>),
        },
      }));
    }
  }

  async onCreateNewExtension(extensionData) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      
      let extensionDataParsed = { ...extensionData };
      
      if (extensionData.group && !extensionData.group.id) {
        const newGroup = await dispatch(IntercomActions.createExtensionGroup({ name: extensionData.group.name }));
        extensionDataParsed.groupId = newGroup.id;
        await dispatch(IntercomActions.fetchExtensionGroups());
      } else if (extensionData.group && extensionData.group.id) {
        extensionDataParsed.groupId = extensionData.group.id;
      }
      
      extensionDataParsed = {
        ...extensionDataParsed,
        userIds: extensionDataParsed.userIds || [],
        visibility: extensionDataParsed.visibility,
        users: undefined,
        group: undefined,
        extensionUserTags: undefined,
        userTagMatchingMode: undefined,
        type: extensionData.isReception ? INTERCOM_EXTENSION_TYPES.RECEPTION : INTERCOM_EXTENSION_TYPES.DEFAULT,
      };
      
      await dispatch(IntercomActions.createExtension(_.omit(extensionDataParsed, ['isReception'])));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchExtensions();
      dispatch(IntercomActions.setExtensionOperationalMode(false));
      dispatch(IntercomActions.selectExtension({}));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionCreatedSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionActionError" /></h6>),
        },
      }));
    }
  }

  async onEditExtension(extensionData) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      
      let extensionDataParsed = { ...extensionData };
      
      if (extensionData.group && !extensionData.group.id) {
        const newGroup = await dispatch(IntercomActions.createExtensionGroup({ name: extensionData.group.name }));
        extensionDataParsed.groupId = newGroup.id;
        await dispatch(IntercomActions.fetchExtensionGroups());
      } else if (extensionData.group && extensionData.group.id) {
        extensionDataParsed.groupId = extensionData.group.id;
      }
      
      extensionDataParsed = {
        ...extensionDataParsed,
        userIds: extensionDataParsed.userIds || [],
        visibility: extensionDataParsed.visibility,
        users: undefined,
        group: undefined,
        extensionUserTags: undefined,
        userTagMatchingMode: undefined,
        type: extensionData.isReception ? INTERCOM_EXTENSION_TYPES.RECEPTION : INTERCOM_EXTENSION_TYPES.DEFAULT,
      };
      
      await dispatch(IntercomActions.editExtension(extensionData.id, _.omit(extensionDataParsed, ['isReception'])));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchExtensions();
      dispatch(IntercomActions.setExtensionOperationalMode(false));
      dispatch(IntercomActions.selectExtension({}));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionUpdatedSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionActionError" /></h6>),
        },
      }));
    }
  }

  onExtensionFormSubmit(extensionData) {
    if (extensionData && extensionData.id) {
      this.onEditExtension(extensionData);
    } else {
      this.onCreateNewExtension(extensionData);
    }
  }

  onOpenInfo() {
    const helpLink = localizeHelpCenterLink('luckey-intercom-addon');
    window.open(helpLink);
  }

  filterUserTags(value) {
    const { dispatch } = this.props;
    const includeSpecialTags = true;
    dispatch(TagActions.cancelFetchGuestTagsByFilter());
    dispatch(TagActions.fetchGuestTagsByFilter(value, 100, includeSpecialTags));
  }

  fetchUsersByTags(tags = [], page = 0, userTagMatchingMode = MATCH_TAG_MODE.EVERY_TAG, append = false) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.cancelFetchExtensionUsersByTags());
    dispatch(IntercomActions.fetchExtensionUsersByTags(tags, userTagMatchingMode, page, append));
    dispatch(change('ExtensionForm', 'extensionUserTags', tags));
  }

  render() {
    const { userTags, intercom: { isOperationalModeExtensions, selectedExtension, extensions: { pagination }, extensionGroups }, form, themeName, dispatch, viewLoading, virtualIntercomLimits } = this.props;
    const { activeTab } = this.state;
    const numberOfExtensions = pagination && pagination.totalElements ? pagination.totalElements : 0;
    
    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          onFilterChange={value => this.onSetFilter('name', _.trim(value))}
          onNewEntity={() => this.onNewExtensionButtonClicked()}
          onSearchSubmit={() => this.onFetchExtensions()}
          onSearchReset={() => this.onSearchReset()}
          searchGuestContainerStyle={{ width: 280 }}
          newEntityTitle="createNewF"
          searchPlaceholderEntityName="search"
          newEntityIconName="icon-simple-line-icons-user-following"
          isLoading={viewLoading}
          onInfo={() => this.onOpenInfo()}
          onExportElements={format => this.onExportElements(format)}
          numberOfElements={numberOfExtensions}
          selectableFieldName="groupId"
          selectableOptions={[
            (<Entity
              key={"intercomAnyGroupFilter"}
              componentClass={TranslatableOption}
              value={"__ANY__"}
              componentAttribute="text"
              entity={"intercomAnyGroupFilter"}
            />),
            ..._.map(_.sortBy(extensionGroups.content, (group => group.name.toLowerCase())), group =>
              <option value={group.id} key={group.id}>
                {group.name}
              </option>
            )
          ]}
          onSelectOption={value => this.onSetFilter('groupId', value)}
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <IntercomExtensionIconCustom style={{ width: 22 }} />
              <h4 style={{ marginTop: 5 }}>{numberOfExtensions}</h4>
            </div>
          }
        />
        <div className="r-flow-on-phone" style={{ top: 140, position: 'fixed', backgroundColor: 'white' }}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, index) => this.onExtensionsListModeChange(index)}
            TabIndicatorProps={{
              style: { display: 'none' }
            }}
          >
            <Tab icon={<ListViewIcon style={{ fontSize: 30 }} />} />
            <Tab icon={<CardViewIcon style={{ fontSize: 30 }} />} />
          </Tabs>
        </div>
        {activeTab === 0 ? (
          <ExtensionTableView
            canCreateItem={true}
            onNewExtension={() => this.onNewExtensionButtonClicked()}
            onSelectExtension={extension => this.onSelectExtension(extension)}
            onRefreshExtensions={() => this.onFetchExtensions()}
            onFetchExtensionsOnPage={page => this.onFetchExtensionsOnPage(page)}
            onDeleteExtension={extensionId => this.onDeleteExtension(extensionId)}
          />
        ) : null}
        {activeTab === 1 ? (
          <ExtensionListView
            canCreateItem={true}
            onSelectExtension={extension => this.onSelectExtension(extension)}
            onNewExtension={() => this.onNewExtensionButtonClicked()}
          />
        ) : null}
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalModeExtensions}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity="extensionOperationalTitle" />}
          style={{ padding: 10, paddingTop: 0 }}
        >
          <div style={{ padding: 10, paddingBottom: '30%' }}>
            <ExtensionForm
              extension={selectedExtension}
              virtualIntercomLimits={virtualIntercomLimits}
              onSubmit={extensionData => this.onExtensionFormSubmit(extensionData)}
              onShowInfoModal={() => this.onOpenInfo()}
              onDeleteExtension={extensionId => this.onDeleteExtension(extensionId)}
              usersFilteredByTags={selectedExtension && selectedExtension.usersFilteredByTags ? selectedExtension.usersFilteredByTags[0] : []}
              availableUserTags={userTags}
              onUserInputChange={value => this.filterUserTags(value)}
              onUserTagsChange={values => this.fetchUsersByTags(values, 0, form && form.values && form.values.userTagMatchingMode)}
              onFetchMoreUsers={page => this.fetchUsersByTags(form && form.values && form.values.extensionUserTags, page, form && form.values && form.values.userTagMatchingMode, true)}
              onUserFilterModeChange={mode => this.fetchUsersByTags(form && form.values && form.values.extensionUserTags, 0, mode)}
            />
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              onClick={() => dispatch(submit('ExtensionForm'))}
            />
          </div>
        </OperationalView>
      </div>
    );
  }
}

export default IntercomExtensionsManagement; 